import { createSelector } from "reselect"
import { get } from "lodash"
import { getComparisonResourcesAvailability, getComparisonSecuritiesAvailability, getComparisonExperimentsAvailability } from "helpers/comparison-dates"
import { getSecurities } from "helpers/comparison"
import { getIndices } from "selectors/indices"

const EMPTY_ARRAY = []

export const getResearchTopicExperiments = state => get(state, "global.data.topicExperiments.data")
export const getPortfoliosAndBenchmarks = state => get(state, "global.data.benchmarksAndPortfolios.data")
export const getModelEarliestDate = (state, props) => get(props, "modelAvailability.securitiesStartDate")
export const getRawSecuritiesAvailability = state => get(state, "global.data.securities.data.model")
export const getModelCurrentDate = (state, props) => get(props, "modelAvailability.currentDate")

const getRawComparisonItems = (state) => get(state, "modules.researchTopic.comparisonItems", EMPTY_ARRAY)

export const getComparisonSecurities = createSelector(
  [getRawComparisonItems],
  getSecurities,
)

export const getExperimentsAvailability = createSelector(
  [getResearchTopicExperiments, getModelEarliestDate],
  getComparisonExperimentsAvailability,
)

export const getSecuritiesAvailability = createSelector(
  [getRawSecuritiesAvailability, getComparisonSecurities],
  getComparisonSecuritiesAvailability,
)

export const getPortfoliosAndBenchmarksAvailability = createSelector(
  [getPortfoliosAndBenchmarks, getModelEarliestDate, getIndices],
  getComparisonResourcesAvailability,
)
